/**
 * Created by CP.
 */
import { Injectable } from '@angular/core';
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router';

@Injectable()
export class AuthGuard implements CanActivate {
  userType: any;

  constructor(private router: Router) {
    this.userType = JSON.parse(localStorage.getItem('currentUser'));
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (localStorage.getItem('access_token')) {
      // logged in so return true
      return true;
    }
    else{

    this.router.navigate(['/public/sign-in']);
    return false;
    }
  }
  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot){
    if (localStorage.getItem('access_token')) {
      // logged in so return true
      return true;
    }
    else{

    this.router.navigate(['/public/sign-in']);
    return false;
    }
  }
}
